import { connect } from 'react-redux';

import {
  assetRelationsCreate,
  assetRelationsTypesGet,
} from '../../../ducks/asset_relations/actions';
import type { AppState } from '../../../store/types';

const mapStateToProps = (state: AppState) => ({
  relationsOptions: state.assetRelations.relationsTypes,
  labels: state.assetRelations.relationsLabels,
});

const connector = connect(mapStateToProps, {
  assetRelationsCreate,
  assetRelationsTypesGet,
});

export default connector;
